// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3_V2H","ranges":"BmiRanges_ranges__2bDEH"};